module.exports = __webpack_public_path__ + "img/confianza.04e37a01.svg";